<template>
   <div class="mp-asset-container" :class="{active: isActive}">
      <div class="mp-asset-wrapper" @click="handleClickAsset">
         <div class="player">
            <button class="btn-mp-audio-play" :class="{ active: isPlaying }" @click.self="toggleSound()">
               <span>Play</span>
            </button>
            <audio class="audio">
               <source v-bind:src="this.GALLERY_HOST + '/' + asset.c_filename" type="audio/mpeg">
               Your browser does not support this audio format.
            </audio>
            <!-- <audio v-bind:src="'http://dev.metinteractive.net/bard/gallery/' + asset.c_uri"></audio>  -->
         </div>
         <div class="mp-filename" @click="assignAsset">
            <div v-if="asset.c_desc1 !== '' && asset.c_desc1 !== null">{{asset.c_desc1}}</div>
            <div v-else-if="asset.c_name !== '' && asset.c_name !== null">{{asset.c_name}}</div>
            <div v-else >{{asset.c_filename}}</div>
         </div>
         <div class="audio-runtime">
           {{convertDuration(asset.c_duration)}}
         </div>
         <div>
            <div class="btn-info-container">
               <button class="btn-info" v-click-outside="hide" @keyup.esc="hide" @click.self="toggleShowmeta(), toggleSelected()" :class="{ selected: isSelected }"><span>Show Meta Data</span></button>
            </div>
            <transition name="meta-data-transition">
               <div class="meta-data-container" v-if="showMetadata">
                  
                  <m-p-meta-data
                     :assetRecid="asset.recid"
                     :assetType="assetType"
                  >
                  </m-p-meta-data>

                  <!-- <button class="btn-media-lib">Show in Media Library</button> -->

               </div>
            </transition>
         </div>
      </div>
   </div>
</template>

<script>
import MPAsset from './MPAsset';

export default {
   extends: MPAsset,

   props: {
      playingIndex: Number //index of the asset playing
   }
}
</script>